
define(
	'Tavano.TavanoteamGA4.TTGA4'
	, [
		'Tavano.TavanoteamGA4.TTGA4.Shopping'
		, 'Tavano.TavanoteamGA4.TTGA4.MyAccount'
		, 'Tavano.TavanoteamGA4.TTGA4.Checkout'
		, 'ProductList.Control.View'
		, 'Header.MiniCart.View'
		, 'Tracker'
		, 'Utils'
	]
	, function (
		TTGA4Shopping
		, TTGA4MyAccount
		, TTGA4Checkout
		, ProductListControlView
		, HeaderMiniCartView
		, Tracker
		, Utils
	) {
		'use strict';
		return {
			mountToApp: function mountToApp(container) {
				_.extend(ProductListControlView.prototype, {
					doAddItemToList: function (product, productList, dontShowMessage) {
						var self = this;
						var product_list_line_to_save = this.getNewItemData(product, productList);
						return product_list_line_to_save.save(null, {
							validate: false,
							success: function (product_list_line_to_save_saved) {
								productList.get('items').add(product_list_line_to_save_saved);
								Tracker.getInstance().trackAddToWishlist(self.product);
								TTGA4Shopping.trackAddToWishlist(product);
								self.collection.trigger('changed');
								self.render();
								if (!dontShowMessage) {
									self.saveAndShowConfirmationMessage(
										self.$('.ul-product-lists [type="checkbox"]:checked').length > 1
											? Utils.translate('Good! You added this item to your product lists')
											: Utils.translate('Good! You added this item to your product list')
									);
								}
							}
						});
					},
				});
				_.extend(HeaderMiniCartView.prototype, {
					trackEvent: function () {
						//console.log("Test....");
						Tracker.getInstance().trackProceedToCheckout();
						TTGA4Shopping.trackCheckout(container, 'minicart', null, null, null);
					},
				});
				if (SC.ENVIRONMENT.SCTouchpoint == 'shopping') {
					var layout = container.getComponent('Layout');
					layout.addToViewEventsDefinition(
						'Cart.Summary.View',
						'click [data-action="proceedToCheckout"]',
						function (event) {
							//console.log(event, "Test proceedToCheckout!!!!!");
						}
					);
					TTGA4Shopping.loadGA4Shopping(container);
				}
				else if (SC.ENVIRONMENT.SCTouchpoint == 'myaccount') {
					TTGA4MyAccount.loadGA4MyAccount(container);
				}
				else if (SC.ENVIRONMENT.SCTouchpoint == 'checkout') {
					var userprofilecomponent = container.getComponent("UserProfile");
					var checkout = container.getComponent('Checkout');
					if (userprofilecomponent) {
						// Begin Checkout
						userprofilecomponent.getUserProfile().then(function (profile) {
							if (checkout && profile && profile.isloggedin) {
								setTimeout(function () {
									TTGA4Checkout.sendCheckoutInfo(container);
								}, 3000);
							}
						}).done(function () {
							TTGA4Checkout.loadGA4Checkout(container);
						});
					}
				}
			}
		};
	});
